import * as React from 'react';
import { Typography } from '@mui/material';
import Column from '../Column';
import NoResultsIcon from '../Icons/NoResults';

export interface Props {
  description?: string;
  cta?: React.ReactNode;
  style?: React.CSSProperties;
  width?: number | string;
  maxWidth?: number | string;
  title?: string;
  marginBottom?: number | string;
  customTestId?: string;
  titleStyle?: React.CSSProperties;
  descriptionStyle?: React.CSSProperties;
}

const EmptyState: React.FC<Props> = ({
  description,
  cta,
  style,
  width = '100%',
  title = 'No data available',
  maxWidth = '90px',
  marginBottom = '10px',
  customTestId = 'empty-state',
  titleStyle,
  descriptionStyle,
}) => {
  return (
    <Column grow centered style={style} testId={customTestId}>
      <div style={{ marginBottom: marginBottom }}>
        <NoResultsIcon size={width} style={{ maxWidth: maxWidth }} />
      </div>
      <Typography variant="body1" color="#ABAAAA" style={titleStyle}>
        {title}
      </Typography>
      <>
        {description && <Typography style={descriptionStyle}>{description}</Typography>}
        {cta}
      </>
    </Column>
  );
};

export default EmptyState;
